<template>
  <v-container class="pt-0 pb-0">
    <v-autocomplete
      v-if="this.type === 'assets'"
      :disabled="disabled"
      v-model="localSelected"
      :items="assets"
      item-text="Name"
      item-value="Id"
      :menu-props="{ maxHeight: '400' }"
      :clearable="true"
      :chips="true"
      :small-chips="true"
      :hide-details="true"
      :label="label"
      deletable-chips
      multiple
      :search-input.sync="search"
      @change="search = ''"
    >
    </v-autocomplete>
    <v-autocomplete
      v-if="this.type === 'sectors'"
      :disabled="disabled"
      v-model="localSelected"
      :items="sectors"
      item-text="Name"
      item-value="Id"
      :menu-props="{ maxHeight: '400' }"
      :clearable="true"
      :chips="true"
      :small-chips="true"
      :hide-details="true"
      :label="label"
      deletable-chips
      multiple
      :search-input.sync="search"
      @change="search = ''"
    >
    </v-autocomplete>

    <v-autocomplete
      v-if="this.type === 'perpetrators'"
      :disabled="disabled"
      v-model="localSelected"
      :items="perpetrators"
      item-text="Name"
      item-value="Id"
      :menu-props="{ maxHeight: '400' }"
      :clearable="true"
      :chips="true"
      :small-chips="true"
      :hide-details="true"
      :label="label"
      deletable-chips
      multiple
      :search-input.sync="search"
      @change="search = ''"
    >
    </v-autocomplete>

    <v-autocomplete
      v-if="this.type === 'attackTypes'"
      :disabled="disabled"
      v-model="localSelected"
      :items="attackTypes"
      item-text="Name"
      item-value="Id"
      :menu-props="{ maxHeight: '400' }"
      :clearable="true"
      :chips="true"
      :small-chips="true"
      :hide-details="true"
      :label="label"
      deletable-chips
      multiple
      :search-input.sync="search"
      @change="search = ''"
    >
    </v-autocomplete>

    <v-autocomplete
      v-if="this.type === 'maritimeSubcategories'"
      :disabled="disabled"
      v-model="localSelected"
      :items="maritimeSubcategories"
      item-text="Name"
      item-value="Id"
      :menu-props="{ maxHeight: '400' }"
      :clearable="true"
      :chips="true"
      :small-chips="true"
      :hide-details="true"
      :label="label"
      deletable-chips
      multiple
      :search-input.sync="search"
      @change="search = ''"
    >
    </v-autocomplete>

    <v-autocomplete
      v-if="this.type === 'maritimeVesselTypes'"
      :disabled="disabled"
      v-model="localSelected"
      :items="maritimeVesselTypes"
      item-text="Name"
      item-value="Id"
      :menu-props="{ maxHeight: '400' }"
      :clearable="true"
      :chips="true"
      :small-chips="true"
      :hide-details="true"
      :label="label"
      deletable-chips
      multiple
      :search-input.sync="search"
      @change="search = ''"
    >
    </v-autocomplete>
  </v-container>
</template>

<script>
const EMITTED_ACTIONS = {
  CHANGE: "change",
};

import ASSETS from "@/common/constants/controlRisks/assets.js";
import { getAttackTypes } from "@/services/events/events.service";
import { getMaritimeSubcategories } from "@/services/events/events.service";
import { getMaritimeVesselTypes } from "@/services/events/events.service";
import { getPerpetrators } from "@/services/events/events.service";
import SECTORS from "@/common/constants/controlRisks/sectors.js";

export default {
  name: "IncidentTypeSelector",
  props: {
    selected: {
      type: Array,
    },
    disabled: {
      type: Boolean,
      default: true,
    },
    label: {
      type: String,
    },
    reset: {
      type: String,
    },
    type: {
      type: String,
    },
  },
  data() {
    return {
      search: "",
      localSelected: [],
      assets: ASSETS,
      attackTypes: getAttackTypes().sort(this.sortOptions),
      maritimeSubcategories: getMaritimeSubcategories().sort(this.sortOptions),
      maritimeVesselTypes: getMaritimeVesselTypes().sort(this.sortOptions),
      perpetrators: getPerpetrators().sort(this.sortOptions),
      sectors: SECTORS.sort(this.sortOptions),
    };
  },
  mounted() {
    this.handleValueChange();
  },
  methods: {
    handleValueChange() {
      if (this.selected) {
        this.localSelected = this.selected;
      } else {
        this.localSelected = null;
      }
    },
    filterOptions(search, item) {
      return (
        !search ||
        item.Name.toLowerCase().indexOf(this.search.toLowerCase()) > -1
      );
    },
    sortOptions(a, b) {
      var nameA = a.Name.toLowerCase();
      var nameB = b.Name.toLowerCase();
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    },
    filterFunction(item, queryText, itemText) {
      return (
        !queryText ||
        itemText.toLowerCase().indexOf(queryText.toLowerCase()) > -1
      );
    },
  },
  watch: {
    selected: {
      handler() {
        this.handleValueChange();
      },
    },
    localSelected: {
      handler() {
        this.$emit(EMITTED_ACTIONS.CHANGE, this.localSelected);
      },
    },
    reset: {
      handler() {
        this.handleValueChange();
      },
    },
  },
};
</script>

<style scoped></style>
